module.exports = __webpack_public_path__ + "static/img/1.824e26a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/zh/1.png
// module id = RoT8
// module chunks = 0